import React, { useContext, useMemo, useState } from 'react';
import proptypes from 'prop-types';
const { arrayOf, bool, func, oneOf, instanceOf, oneOfType, shape, string, any } = proptypes;
import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  IconButton,
  Popover,
  TextField,
  Tile,
  TileGroup,
  Typography
} from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const PopoverFeedBackForm = (
  {
    open,
    anchorEl,
    onClose,
    onSubmit
  }
) => {
  const [feedbackReason, setFeedbackReason] = useState('');
  const [feedbackComment, setFeedbackComment] = useState('');
  const [canSubmit, setCanSubmit] = useState(false);
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const title = 'Why did you select this feedback?';
  const reasons = [
    'Inaccurate',
    'Irrelevant',
    'Unsafe/Offensive',
    'Other'
  ];

  const handleSelectReason = (__, selected) => {
    setFeedbackReason(selected);
    setCanSubmit(true);
  };

  const populateReasonOptions = () => {
    return reasons?.map(
      (item) => <Tile variant="outline" value={item} key={item}>{item}</Tile>);
  };

  const handleChange = (event) => setFeedbackComment(event.target.value);

  const handleClose = (event) => onClose(event);

  const handleSubmit = () => onSubmit({
    reason: feedbackReason,
    comment: feedbackComment
  });

  return isMobile ? (
    <Drawer open={open} onClose={handleClose} anchor="bottom">
      <DrawerHeader title={title} onClose={handleClose} />
      <DrawerBody>
        <section className="sui-flex sui-flex-col sui-gap-2 sui-mb-4">
          <TileGroup
            value={feedbackReason}
            onChange={handleSelectReason}
            aria-label="Reason options"
          >
            {populateReasonOptions()}
          </TileGroup>
          <TextField placeholder="Add details here" onChange={handleChange} multiline minRows={3} fullWidth />
        </section>
      </DrawerBody>
      <DrawerFooter>
        <Button
          id="list-agent-user-feedback_submit"
          onClick={handleSubmit}
          disabled={!canSubmit}
          variant="primary"
          fullWidth
        >
          Submit
        </Button>
      </DrawerFooter>
    </Drawer>
  ) : (
    <Popover open={open} anchorEl={anchorEl?.current || anchorEl} placement="left">
      <header className="sui-flex sui-justify-between sui-items-center sui-gap-2 sui-mb-4">
        <Typography variant="body-base" weight="bold">{title}</Typography>{' '}
        <IconButton
          icon={Close}
          size="small"
          onClick={handleClose}
          aria-label="Close"
        />
      </header>
      <section className="sui-flex sui-flex-col sui-gap-2 sui-mb-4">
        <TileGroup
          value={feedbackReason}
          onChange={handleSelectReason}
          aria-label="Reason options"
          className="sui-flex sui-gap-1 sui-flex-wrap sui-w-full"
        >
          {populateReasonOptions()}
        </TileGroup>
        <TextField placeholder="Add details here" onChange={handleChange} multiline minRows={3} fullWidth />
      </section>
      <footer className="sui-w-full">
        <Button
          id="list-agent-user-feedback_submit"
          onClick={handleSubmit}
          disabled={!canSubmit}
          variant="primary"
          fullWidth
        >
          Submit
        </Button>
      </footer>
    </Popover>
  );
};

PopoverFeedBackForm.displayName = 'PopoverFeedBackForm';

PopoverFeedBackForm.propTypes = {
  open: bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: oneOfType([shape({ current: any }), func]),
  onClose: func.isRequired,
  onSubmit: func.isRequired
};

PopoverFeedBackForm.defaultProps = {
  anchorEl: null
};
